import type { FontFile } from './font-file';

export interface Font {
    id: number;
    family: string;
    weight: number;
    style: string;
    organization: number;
    fontFile: FontFile;
}

export interface FontDescription {
    family: string;
    weight: number;
    style: string;
}
